'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var enAtomsContext = require.context('./en/atoms', true, /\.json$/);
var enMoleculesContext = require.context('./en/molecules', true, /\.json$/);
var enOrganismsContext = require.context('./en/organisms', true, /\.json$/);
var frAtomsContext = require.context('./fr/atoms', true, /\.json$/);
var frMoleculesContext = require.context('./fr/molecules', true, /\.json$/);
var frOrganismsContext = require.context('./fr/organisms', true, /\.json$/);

// Helper function to process all translations
var importAllTranslations = function importAllTranslations(context) {
    var translations = {};
    context.keys().forEach(function (key) {
        var moduleName = key.replace(/^\.\/|\.json$/g, '');
        try {
            translations[moduleName] = context(key);
        } catch (error) {
            console.log('Error loading module ' + moduleName + ' from ' + key + ':', error);
        }
    });
    return translations;
};

// Process all translations
var enAtomTranslations = importAllTranslations(enAtomsContext);
var enMoleculeTranslations = importAllTranslations(enMoleculesContext);
var enOrganismTranslations = importAllTranslations(enOrganismsContext);

var frAtomTranslations = importAllTranslations(frAtomsContext);
var frMoleculeTranslations = importAllTranslations(frMoleculesContext);
var frOrganismTranslations = importAllTranslations(frOrganismsContext);

// Consolidate English translations
var enMessages = exports.enMessages = _extends({}, Object.values(enAtomTranslations).reduce(function (acc, curr) {
    return _extends({}, acc, curr);
}, {}), Object.values(enMoleculeTranslations).reduce(function (acc, curr) {
    return _extends({}, acc, curr);
}, {}), Object.values(enOrganismTranslations).reduce(function (acc, curr) {
    return _extends({}, acc, curr);
}, {}));

// Consolidate French translations
var frMessages = exports.frMessages = _extends({}, Object.values(frAtomTranslations).reduce(function (acc, curr) {
    return _extends({}, acc, curr);
}, {}), Object.values(frMoleculeTranslations).reduce(function (acc, curr) {
    return _extends({}, acc, curr);
}, {}), Object.values(frOrganismTranslations).reduce(function (acc, curr) {
    return _extends({}, acc, curr);
}, {}));

exports.default = {
    en: enMessages,
    fr: frMessages
};